export default __webpack_public_path__ + "static/media/earn.0f6290c0.png";